"use strict";
/// <reference path="../typings/json.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
var aggregate = require("./aggregate");
exports.aggregate = aggregate;
var axis = require("./axis");
exports.axis = axis;
var bin = require("./bin");
exports.bin = bin;
var channel = require("./channel");
exports.channel = channel;
var compositeMark = require("./compositemark");
exports.compositeMark = compositeMark;
var compile_1 = require("./compile/compile");
exports.compile = compile_1.compile;
var config = require("./config");
exports.config = config;
var data = require("./data");
exports.data = data;
var datetime = require("./datetime");
exports.datetime = datetime;
var encoding = require("./encoding");
exports.encoding = encoding;
var facet = require("./facet");
exports.facet = facet;
var fieldDef = require("./fielddef");
exports.fieldDef = fieldDef;
var legend = require("./legend");
exports.legend = legend;
var mark = require("./mark");
exports.mark = mark;
var scale = require("./scale");
exports.scale = scale;
var sort = require("./sort");
exports.sort = sort;
var spec = require("./spec");
exports.spec = spec;
var stack = require("./stack");
exports.stack = stack;
var timeUnit = require("./timeunit");
exports.timeUnit = timeUnit;
var transform = require("./transform");
exports.transform = transform;
var type = require("./type");
exports.type = type;
var util = require("./util");
exports.util = util;
var validate = require("./validate");
exports.validate = validate;
var package_json_1 = require("./package.json");
exports.version = package_json_1.version;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDZDQUE2Qzs7QUFFN0MsdUNBQXlDO0FBOEJqQyw4QkFBUztBQTdCakIsNkJBQStCO0FBNkJaLG9CQUFJO0FBNUJ2QiwyQkFBNkI7QUE0Qkosa0JBQUc7QUEzQjVCLG1DQUFxQztBQTJCUCwwQkFBTztBQTFCckMsK0NBQWlEO0FBMEJWLHNDQUFhO0FBeEJwRCw2Q0FBMEM7QUFBbEMsNEJBQUEsT0FBTyxDQUFBO0FBRWYsaUNBQW1DO0FBc0JtQix3QkFBTTtBQXJCNUQsNkJBQStCO0FBcUIrQixvQkFBSTtBQXBCbEUscUNBQXVDO0FBb0I2Qiw0QkFBUTtBQW5CNUUscUNBQXVDO0FBbUJ1Qyw0QkFBUTtBQWxCdEYsK0JBQWlDO0FBa0J1RCxzQkFBSztBQWpCN0YscUNBQXVDO0FBaUJ3RCw0QkFBUTtBQWhCdkcsaUNBQW1DO0FBZ0JzRSx3QkFBTTtBQWYvRyw2QkFBK0I7QUFla0Ysb0JBQUk7QUFkckgsK0JBQWlDO0FBY3NGLHNCQUFLO0FBYjVILDZCQUErQjtBQWErRixvQkFBSTtBQVpsSSw2QkFBK0I7QUFZcUcsb0JBQUk7QUFYeEksK0JBQWlDO0FBV3lHLHNCQUFLO0FBVi9JLHFDQUF1QztBQVUwRyw0QkFBUTtBQVR6Six1Q0FBeUM7QUFTa0gsOEJBQVM7QUFScEssNkJBQStCO0FBUXVJLG9CQUFJO0FBUDFLLDZCQUErQjtBQU82SSxvQkFBSTtBQU5oTCxxQ0FBdUM7QUFNMkksNEJBQVE7QUFKMUwsK0NBRXdCO0FBRHRCLGlDQUFBLE9BQU8sQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbIi8vLyA8cmVmZXJlbmNlIHBhdGg9XCIuLi90eXBpbmdzL2pzb24uZC50c1wiIC8+XG5cbmltcG9ydCAqIGFzIGFnZ3JlZ2F0ZSBmcm9tICcuL2FnZ3JlZ2F0ZSc7XG5pbXBvcnQgKiBhcyBheGlzIGZyb20gJy4vYXhpcyc7XG5pbXBvcnQgKiBhcyBiaW4gZnJvbSAnLi9iaW4nO1xuaW1wb3J0ICogYXMgY2hhbm5lbCBmcm9tICcuL2NoYW5uZWwnO1xuaW1wb3J0ICogYXMgY29tcG9zaXRlTWFyayBmcm9tICcuL2NvbXBvc2l0ZW1hcmsnO1xuZXhwb3J0IHtUb3BMZXZlbFNwZWN9IGZyb20gJy4vc3BlYyc7XG5leHBvcnQge2NvbXBpbGV9IGZyb20gJy4vY29tcGlsZS9jb21waWxlJztcbmV4cG9ydCB7Q29uZmlnfSBmcm9tICcuL2NvbmZpZyc7XG5pbXBvcnQgKiBhcyBjb25maWcgZnJvbSAnLi9jb25maWcnO1xuaW1wb3J0ICogYXMgZGF0YSBmcm9tICcuL2RhdGEnO1xuaW1wb3J0ICogYXMgZGF0ZXRpbWUgZnJvbSAnLi9kYXRldGltZSc7XG5pbXBvcnQgKiBhcyBlbmNvZGluZyBmcm9tICcuL2VuY29kaW5nJztcbmltcG9ydCAqIGFzIGZhY2V0IGZyb20gJy4vZmFjZXQnO1xuaW1wb3J0ICogYXMgZmllbGREZWYgZnJvbSAnLi9maWVsZGRlZic7XG5pbXBvcnQgKiBhcyBsZWdlbmQgZnJvbSAnLi9sZWdlbmQnO1xuaW1wb3J0ICogYXMgbWFyayBmcm9tICcuL21hcmsnO1xuaW1wb3J0ICogYXMgc2NhbGUgZnJvbSAnLi9zY2FsZSc7XG5pbXBvcnQgKiBhcyBzb3J0IGZyb20gJy4vc29ydCc7XG5pbXBvcnQgKiBhcyBzcGVjIGZyb20gJy4vc3BlYyc7XG5pbXBvcnQgKiBhcyBzdGFjayBmcm9tICcuL3N0YWNrJztcbmltcG9ydCAqIGFzIHRpbWVVbml0IGZyb20gJy4vdGltZXVuaXQnO1xuaW1wb3J0ICogYXMgdHJhbnNmb3JtIGZyb20gJy4vdHJhbnNmb3JtJztcbmltcG9ydCAqIGFzIHR5cGUgZnJvbSAnLi90eXBlJztcbmltcG9ydCAqIGFzIHV0aWwgZnJvbSAnLi91dGlsJztcbmltcG9ydCAqIGFzIHZhbGlkYXRlIGZyb20gJy4vdmFsaWRhdGUnO1xuXG5leHBvcnQge1xuICB2ZXJzaW9uXG59IGZyb20gJy4vcGFja2FnZS5qc29uJztcblxuZXhwb3J0IHthZ2dyZWdhdGUsIGF4aXMsIGJpbiwgY2hhbm5lbCwgY29tcG9zaXRlTWFyaywgY29uZmlnLCBkYXRhLCBkYXRldGltZSwgZW5jb2RpbmcsIGZhY2V0LCBmaWVsZERlZiwgbGVnZW5kLCBtYXJrLCBzY2FsZSwgc29ydCwgc3BlYywgc3RhY2ssIHRpbWVVbml0LCB0cmFuc2Zvcm0sIHR5cGUsIHV0aWwsIHZhbGlkYXRlfTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-lite/build/src/index.js
// module id = 1288
// module chunks = 0